import React from "react";
import { META_PIXEL_ID } from "./data/content";
import { useMetaPixel } from "./hooks/useMetaPixel";
import { Hero } from "./components/Hero";
import { PainStatement } from "./components/PainStatement";
import { SearchProblem } from "./components/SearchProblem";
import { SystemOverview } from "./components/SystemOverview";
import { Modules } from "./components/Modules";
import { Gallery } from "./components/Gallery";
import { Bonuses } from "./components/Bonuses";
import { NotAnEbook } from "./components/NotAnEbook";
import { Offer } from "./components/Offer";
import { Guarantee } from "./components/Guarantee";
import { Faq } from "./components/Faq";
import { FinalQuestion } from "./components/FinalQuestion";
import { Footer } from "./components/Footer";
import { StickyBuyBar } from "./components/StickyBuyBar";
export function App() {
  useMetaPixel(META_PIXEL_ID);
  return <div className="min-h-screen w-full bg-mist font-sans text-navy antialiased" data-id="element-0" data-mp="23vkv2fqfs7kp">
      <div className="mx-auto w-full max-w-[720px] overflow-hidden bg-white shadow-[0_0_40px_-12px_rgba(13,42,71,0.25)]" data-id="element-1" data-mp="23ti5txx3yih1">
        <Hero data-id="element-2" data-mp="3ml1419v3fqjj" />
        <main data-id="element-3" data-mp="3mkrgru1fnxhj">
          <PainStatement data-id="element-4" data-mp="3mk84asujy1aw" />
          <SearchProblem data-id="element-5" data-mp="3mjg8bgx1m1k3" />
          <SystemOverview data-id="element-6" data-mp="3rcj6y3gog175" />
          <Modules data-id="element-7" data-mp="3rdaquh0wwahl" />
          <Gallery data-id="element-8" data-mp="3rcsyvwla8ifh" />
          <Bonuses data-id="element-9" data-mp="3recdlirailf5" />
          <NotAnEbook data-id="element-10" data-mp="5yhgo69t1c8" />
          <Offer data-id="element-11" data-mp="67yhm9c7y5s" />
          <Guarantee data-id="element-12" data-mp="4n53zyrel9i" />
          <Faq data-id="element-13" data-mp="56l3b4umzkw" />
          <FinalQuestion data-id="element-14" data-mp="7ssnarqpf34" />
        </main>
        <Footer data-id="element-15" data-mp="2zlv8x0aavbxp" />
      </div>
      <StickyBuyBar data-id="element-16" data-mp="2zmo5j8fjol24" />
    </div>;
}